var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217 217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#037015;stroke:#029b1c;stroke-miterlimit:10;stroke-width:7px;}.cls-2{fill:#029b1c;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tile icon MOB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.5,
    y: 3.5,
    width: 210,
    height: 210,
    rx: 23.6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.54 187.3 200.39 36.56 80.84 53.27 159.92 69.98 111.54 187.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "148.41 78.14 104.23 187.3 16.61 38.79 94.21 136.8 148.41 78.14"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "94.21 124.18 19.21 28.77 192.96 28.77 68.96 46.59 94.21 124.18"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "83.69 61.75 99.28 120.41 141.85 76.47 83.69 61.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.19,156.53c2.32-10.06,5.65-23.45,7.68-31.09h-.45c-6.08,13.8-14.89,33.28-24,52.09h-16c.22-16.85.05-37.76.73-52.08h-.58C48.41,133,45.75,146,43.18,157l-4.77,20.49H20.7l15-64.37H64.37c.1,12.24-.32,31.73-.9,41.18h.36C68.06,143.81,75.91,128,83,113.16h28.34l-15,64.37h-19Z",
    transform: "translate(-1.23 -1.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.84,151.58c0,13-7.89,26.76-27.5,26.76-14,0-20-8.15-20-17.83,0-13.09,8.8-27.39,27.09-27.39C148.54,133.12,154.84,141.46,154.84,151.58Zm-33.75,9.16c0,5.21,2.3,8.76,7.72,8.76,9.2,0,12.48-11.52,12.48-18.67,0-4.86-1.82-8.88-7.55-8.88C125.11,142,121.09,153.24,121.09,160.74Z",
    transform: "translate(-1.23 -1.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164,133.93h20.59c10.59,0,15.1,4.82,15.1,10.82,0,5.06-3.22,8.88-8.41,10.5a9.4,9.4,0,0,1,6.12,8.67c0,8.25-7.13,13.61-19.58,13.61h-24Zm4.71,35.35h7.18c4.74,0,7.53-2,7.53-5.49,0-2.87-1.77-4.54-6.44-4.54h-6ZM179.43,151c4.09,0,6.92-1.48,6.92-4.84,0-3-2.43-4-5.17-4H175l-2,8.8Z",
    transform: "translate(-1.23 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobile);
export default __webpack_public_path__ + "static/media/icon-MOBILE.c7741546eab45d83ee5a7695607138a2.svg";
export { ForwardRef as ReactComponent };